"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _provider = _interopRequireDefault(require("./provider"));

var _state = _interopRequireDefault(require("./state"));

var _reducer = _interopRequireDefault(require("./reducer"));

var _context = _interopRequireDefault(require("./context"));

var _trebleCore = _interopRequireDefault(require("./treble-core"));

var _ = require(".");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function Treble(_ref) {
  var _store$options;

  var children = _ref.children,
      store = _ref.store;

  try {
    if (_typeof(store) !== "object") {
      throw new TypeError("TrebleGSM: Treble store prop must be an array.");
    }
  } catch (error) {
    throw error;
  }

  var trebleCoreData = store !== null && store !== void 0 && store.scope ? (store === null || store === void 0 ? void 0 : (_store$options = store.options) === null || _store$options === void 0 ? void 0 : _store$options.inheritModules) !== false ? (0, _.useTreble)(_context["default"])[0].trebleCoreData : {
    moduleData: []
  } : {
    moduleData: []
  };
  var inheritedModules = trebleCoreData !== null && trebleCoreData !== void 0 && trebleCoreData.moduleData ? _toConsumableArray(trebleCoreData.moduleData) : [];
  var storeModules = store !== null && store !== void 0 && store.modules ? _toConsumableArray(store === null || store === void 0 ? void 0 : store.modules) : [];

  var importedModules = function importedModules() {
    if (store !== null && store !== void 0 && store.modules) {
      var data = [];
      store === null || store === void 0 ? void 0 : store.modules.map(function (module) {
        if (module !== null && module !== void 0 && module.importModules) {
          data = [].concat(_toConsumableArray(data), _toConsumableArray(module.importModules));
        }
      });
      return data;
    }

    return [];
  };

  var noDuplicateModules = function noDuplicateModules(inheritedModules, storeModules) {
    if (inheritedModules.length > 0) {
      var cleanedModules = inheritedModules === null || inheritedModules === void 0 ? void 0 : inheritedModules.filter(function (inheritedModule) {
        storeModules === null || storeModules === void 0 ? void 0 : storeModules.map(function (storeModule) {
          if (storeModule.name !== inheritedModule.name && storeModule.name !== 'treble-core') {
            return inheritedModule;
          }
        });
      });
      return [].concat(_toConsumableArray(cleanedModules), _toConsumableArray(storeModules));
    }

    return storeModules;
  };

  var Store = (0, _react.useMemo)(function () {
    return store.data;
  }, [store.data]),
      Modules = [_trebleCore["default"]].concat(_toConsumableArray(noDuplicateModules(importedModules(), noDuplicateModules(inheritedModules, storeModules)))),
      Reducer = (0, _reducer["default"])(_toConsumableArray(Store), Modules),
      State = (0, _state["default"])(_toConsumableArray(Store), Modules),
      defaultContext = _context["default"],
      scopedContext = store === null || store === void 0 ? void 0 : store.scope;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_provider["default"], {
    initialState: State,
    reducer: Reducer,
    store: Store,
    scope: scopedContext !== undefined ? scopedContext : defaultContext,
    modules: Modules
  }, _react["default"].createElement(_react["default"].Fragment, null, children)));
}

var _default = Treble;
exports["default"] = _default;
module.exports = exports.default;